import {KeyframedMoviePath, MoviePath} from 'common/src/modules/movie/moviePrimitives.types';
import {getActualPercentComplete} from 'common/src/modules/movie/utils/getMovieValue';

function isSimpleMoviePath(path: MoviePath | KeyframedMoviePath): path is MoviePath {
  return 'val' in path && !!path.val;
}

function getMaskPathValue(path: MoviePath | KeyframedMoviePath, time: number): MoviePath {
  if (isSimpleMoviePath(path)) return path;

  for (let i = 0; i < path.k.length; i++) {
    const keyframe = path.k[i];

    if (time / 1000 > keyframe.t) continue;

    const prevKeyframe = path.k[i - 1];
    if (!prevKeyframe)
      return {
        c: path.c,
        val: path.k[0].s[0],
      };

    const percentComplete = (time / 1000 - prevKeyframe.t) / (keyframe.t - prevKeyframe.t);
    const actualPercentComplete = getActualPercentComplete(0, prevKeyframe, percentComplete);

    function mergeValue([sx, sy]: number[], [ex, ey]: number[]): [number, number] {
      return [sx + (ex - sx) * actualPercentComplete, sy + (ey - sy) * actualPercentComplete];
    }

    const start = prevKeyframe.s[0],
      end = prevKeyframe.e[0];

    return {
      c: path.c,
      val: {
        i: start.i.map((val, idx) => mergeValue(val, end.i[idx])),
        o: start.o.map((val, idx) => mergeValue(val, end.o[idx])),
        v: start.v.map((val, idx) => mergeValue(val, end.v[idx])),
      },
    };
  }

  return {
    c: path.c,
    val: path.k[path.k.length - 2].e[0],
  };
}

export default getMaskPathValue;
